import React from "react";
import FeeCard from "../modules/Fees/FeesModule/FeeCard";

export function FeeCardPage(props) {
  return (
    <FeeCard {...props} />
  );
}
